window.__COMPONENTS_CORE_SIMPLE_BAR_DISABLED = true;
import('./bootstrap');
